import Button from "../Button";

type Props = {
  header?: string;
  text?: string;
  buttonLabel?: string;
  onClick(): void;
};

const TipCard = ({
  header = "Email Match Found",
  text = "This email is already associated with a person in the system.",
  buttonLabel = "View Existing Person",
  onClick
}: Props) => (
  <div className="bg-sys-brand-secondary-container rounded-xl pt-3 px-3">
    <div className="px-3 pb-2">
      <h1 className="text-title-small mb-1">{header}</h1>
      <p className="text-body-medium">{text}</p>
    </div>

    <Button variant="text" onClick={onClick}>
      {buttonLabel}
    </Button>
  </div>
);

export default TipCard;
